'use client';

import { useState } from "react";
import Image from "next/image";
import styles from "./page.module.css";

export default function ClientPhotographerPage({ photographer, medias }) {
    const [mediaLikes, setMediaLikes] = useState(
        medias.map((m) => ({ id: m.id, likes: m.likes, liked: false }))
    );

    const toggleLike = async (id) => {
        setMediaLikes((prev) =>
        prev.map((m) =>
            m.id === id
            ? {
                ...m,
                liked: !m.liked,
                likes: m.liked ? m.likes - 1 : m.likes + 1,
                }
            : m
        )
        );

        const current = mediaLikes.find((m) => m.id === id);
        const liked = !current.liked;

        // Update DB via API route
        await fetch(`/api/media/${id}/like`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ liked }),
        });
    };

    return(
        <>
            <section className={styles.photographerHeader}>
                <div className={styles.photographerPresentation}>
                    <h1 className={styles.photographerName}>{photographer.name}</h1>
                    <h2 className={styles.photographerLocation}>{photographer.city}, {photographer.country}</h2>
                    <p className={styles.photographerTagline}>{photographer.tagline}</p>
                </div>
                <div className={styles.contactButtonWrapper}>
                    <button className={styles.contactButton}>Contactez-moi</button>
                </div>
                <div className={styles.portraitWrapper}>
                    <Image 
                        src={"/assets/" + photographer.portrait}
                        width={200}
                        height={200}
                        className={styles.photographerPortrait}
                        alt={"Photo de " + photographer.name}
                    />
                </div>
            </section>
            <section className={styles.tags}>

            </section>
            <section className={styles.mediasGrid}>
                {medias.map((media) => {
                    const state = mediaLikes.find((m) => m.id === media.id);
                    return (
                    <article key={media.id} className={styles.media}>
                        {media.image ? (
                        <Image
                            src={"/assets/" + media.image}
                            width={450}
                            height={450}
                            alt=""
                            className={styles.mediaPicture}
                        />
                        ) : (
                        <video
                            width={450}
                            height={450}
                            src={"/assets/" + media.video}
                            controls
                            className={styles.mediaPicture}
                        />
                        )}

                        <div className={styles.mediaContent}>
                        <p className={styles.mediaTitle}>{media.title}</p>
                        <button
                            className={`${styles.mediaLikes} ${state.liked ? styles.liked : ""}`}
                            onClick={() => toggleLike(media.id)}
                        >
                            <p>{state.likes}</p>
                            <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512"
                            fill={state.liked ? "#e63946" : "#901C1C"}
                            className={styles.heartIcon}
                            >
                            <path d="M241 87.1l15 20.7 15-20.7C296 52.5 336.2 32 378.9 32 452.4 32 512 91.6 512 165.1l0 2.6c0 112.2-139.9 242.5-212.9 298.2-12.4 9.4-27.6 14.1-43.1 14.1s-30.8-4.6-43.1-14.1C139.9 410.2 0 279.9 0 167.7l0-2.6C0 91.6 59.6 32 133.1 32 175.8 32 216 52.5 241 87.1z"/>
                            </svg>
                        </button>
                        </div>
                    </article>
                    );
                })}
            </section>
            <aside className={styles.sideInfos}>
                <div className={styles.mediaLikes}>
                    <p>{likes}</p>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"className={styles.heartIcon}><path d="M241 87.1l15 20.7 15-20.7C296 52.5 336.2 32 378.9 32 452.4 32 512 91.6 512 165.1l0 2.6c0 112.2-139.9 242.5-212.9 298.2-12.4 9.4-27.6 14.1-43.1 14.1s-30.8-4.6-43.1-14.1C139.9 410.2 0 279.9 0 167.7l0-2.6C0 91.6 59.6 32 133.1 32 175.8 32 216 52.5 241 87.1z"/></svg>
                </div>
                <p>{photographer.price + "€/jour"}</p>
            </aside>
        </>
    )
}

function getAllLikes(medias){
    let likes = 0;
    medias.forEach(media => {
        likes += media.likes
    });
    return likes;
}